import React from 'react'

function GettingStarted() {
  return (
    <div>
        <h1 className='text-4xl font-bold'>Getting Started</h1>
<h2 className='mt-5 text-2xl'>Welcome to the College API! This API provides information about undergraduate engineering colleges in India approved by the All India Council for Technical Education (AICTE), including details about their respective states.</h2>
    </div>
  )
}

export default GettingStarted